import React from "react";
import { Row, Col, Card, CardBody, Input, Button } from "reactstrap";
import { getGridLineColor } from '../../helpers/utils'
import Switch from '@mui/material/Switch';

const PanelPasswordComponent = ({
  devices,
  onClick,
  onChange
}) => {
  return (
    <>
      <Row>
        <Col>           
          {devices.map((item, index) => (
            <Card key={index} style={{ cursor: "pointer", marginBottom: "0px" }} >
              <CardBody style={{padding: "0px", paddingLeft: "5px", backgroundColor: (index % 2 === 0 ? "inherit" : getGridLineColor())}}>
                <Row>                  
                  <Col xs={1} md={1} style={{display: "flex", alignItems: "center"}}>
                    {item.deviceId}
                  </Col>
                  <Col xs={2} md={2} style={{display: "flex", alignItems: "center"}}>
                    {item.title}
                  </Col>
                  <Col xs={3} md={3} style={{display: "flex", alignItems: "center"}}>
                    {item.organizationName}
                  </Col>
                  <Col xs={2} md={2} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Switch
                      checked={item.passwordPanelActive}
                      onChange={(e) => onChange(item, "passwordPanelActive", e.target.checked)}
                    />
                  </Col>
                  <Col xs={2} md={2} style={{ display: "flex", alignItems: "center" }}>
                    <Input
                      name="password"
                      type="number"
                      min={1}
                      value={item.panelCurrentPassword}
                      placeholder="Senha atual"
                      className="form-control"
                      onChange={(e) => onChange(item, "panelCurrentPassword", e.target.value)}
                    />
                  </Col>
                  <Col xs={2} md={2} style={{ textAlign: "right" }}>
                      <Button
                        className="btn-fill btn-xs"
                        color="primary"
                        type="button"
                        onClick={()=>onClick(item)}
                      >
                      Salvar
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          ))}
        </Col>
      </Row>
    </>
  );
};

export default PanelPasswordComponent;
